import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createClef } from "../api/CLEF/clef";

export function useCreateApiKey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createClef,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["api-keys"] });
    },
  });
}
